module.exports = __webpack_public_path__ + "static/tfk-cover-13c5b0e1bb5df5dd07a71e0ce7130580.jpg";